import { Dialog } from "@mui/material";
import { useState } from "react";

import DialogContentSelectGeneric from "../DialogsContents/DialogContentGeneric";
import MultipleChipsField from "../../BaseInputs/MultipleChipsField";
import { IDataDepartamentosEstoque } from "../../../types/api/estoque/pesquisar-departamentos-estoque";

export default function SelectDepartamentoEstoqueMultiple({
    value,
    onChange,
    required = false,
    error = false,
    multiple = true
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => setOpenModal(false)

    return (
        <>
            <MultipleChipsField
                value={value}
                required={required}
                label="Departamento"
                formatChipLabel={(item) => `${item.id} - ${item.nome}`}
                onClick={() => setOpenModal(true)}
                error={!!error}
                helperText={error ? "Campo obrigatório" : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ handleClose }}
                        multiple={multiple}
                        possuiBtnLimpar
                        title="Selecionar departamento"
                        queryPath="/estoque/pesquisar-departamentos"
                        getItemKey={(item) => item?.id ?? 0}
                        getItemLabel={(item) => item ? `${item.id} - ${item.nome}` : ''}
                        defaultValue={value ?? []}
                        onChange={(value) => {
                            onChange(value as IDataDepartamentosEstoque[])
                            handleClose()
                        }}
                    />
                </Dialog>

            }
        </>
    )
}

interface SelectSimpleApiQueryProps {
    value: IDataDepartamentosEstoque[] | null;
    onChange: (arg: IDataDepartamentosEstoque[] | null) => void;
    error?: boolean;
    required?: boolean;
    multiple?: boolean;
}